<template>
	<div class="environment">
		<ul class="environment__list" :variant="variant">
			<li
				class="environment__item"
				:key="item.id + index"
				v-for="(item, index) in itemsMapped"
			>
				<EnvironmentCard
					:modelValue="item"
					@showCustomerCompanyLocations="showCCLModal(item)"
				>
					<template #checkbox>
						<Checkbox
							:value="item.id"
							:id="item.id"
							:modelValue="item.checkedValue"
							@input="getValue"
						/>
					</template>
				</EnvironmentCard>
			</li>
		</ul>
		<CCLSDetailsModal
			:title="titleModal"
			:display="showCompaniesLocationsModal"
			:apiCall="getCompaniesLocationsResultApi"
			:successCompaniesLocationsApi="successCompaniesLocationsApi"
			:renderSource="true"
			:loading="modalLoading"
			:placeholder="'Search by company name/# or location name'"
			@close="closeCCLsDetailModal"
		/>
	</div>
</template>

<script>
import EnvironmentCard from '@/sections/environment/summary/environment-summary-card.vue';
import CCLSDetailsModal from '@/sections/environment/CCLsDetailModal/ccls-details-modal.vue';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
	name: 'EnvironmentSummaryList',
	components: {
		EnvironmentCard,
		CCLSDetailsModal,
		Checkbox
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		items: {
			type: Array,
			default: () => []
		},
		value: {
			type: Array,
			default: () => []
		},
		resetSelectedCheckboxes: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			titleModal: '',
			modalLoading: false,
			successCompaniesLocationsApi: false,
			showCompaniesLocationsModal: false,
			companies: [],
			locations: [],
			companiesAndLocations: {},
			localValue: [],
			itemsMapped: []
		};
	},
	computed: {
		...mapGetters('customer', ['customer'])
	},
	methods: {
		setTitleModal(customer) {
			if (customer.environmentName) {
				this.titleModal = `${customer.dealershipGroup} CCLs - ${customer.environmentName}`;
			} else {
				this.titleModal = `${customer.dealershipGroup} CCLs`;
			}
		},
		showCCLModal(customer) {
			this.$store.commit('customer/SetCustomer', customer);
			this.setTitleModal(customer);
			this.showCompaniesLocationsModal = true;
		},
		getCompaniesAndLocations() {
			this.companies = this.customer.companies?.map(cn => {
				return {
					text: `(${cn.companyNumber}) ${cn.companyName}`,
					value: cn.id
				};
			});
			this.customer.companies?.forEach(company => {
				company.locations?.map(lo => {
					this.locations.push({
						text: `(${lo.locationNumber}) ${lo.locationName}`,
						value: lo.id
					});
				});
			});

			return { companies: this.companies, locations: this.locations };
		},
		loadCompaniesAndLocations() {
			this.successCompaniesLocationsApi = true;
			this.companiesAndLocations = this.getCompaniesAndLocations();
		},
		getCompaniesLocationsResultApi() {
			return this.companiesAndLocations;
		},
		initializedVariables() {
			this.showCompaniesLocationsModal = false;
			this.modalLoading = false;
			this.companies = [];
			this.locations = [];
			this.companiesAndLocations = {};
		},
		closeCCLsDetailModal() {
			this.initializedVariables();
		},
		getValue(value, isSelected) {
			const checkUnckedElement = (id, selected = true) => {
				let item = this.itemsMapped.find(item => item.id === id);
				if (!_.isEmpty(item)) {
					if (selected) {
						item.checkedValue = id;
					} else {
						item.checkedValue = '';
					}
				}
			};

			const exists = this.localValue.find(val => val === value);
			if (isSelected && !exists) {
				this.localValue.push(value);
				checkUnckedElement(value);
			}
			if (!isSelected && exists) {
				let indice = this.localValue.indexOf(value);
				this.localValue.splice(indice, 1);
				checkUnckedElement(value, false);
			}
			this.$emit('input', this.localValue);
		},
		resetCheckedValues() {
			this.$nextTick(() => {
				this.itemsMapped = this.itemsMapped.map(item => {
					return {
						...item,
						checkedValue: ''
					};
				});
			});
		}
	},
	watch: {
		showCompaniesLocationsModal: {
			immediate: true,
			handler(val) {
				if (val) {
					this.loadCompaniesAndLocations();
				}
			}
		},
		value: {
			deep: true,
			immediate: true,
			handler(val) {
				this.localValue = [...val];
			}
		},
		items: {
			deep: true,
			immediate: true,
			handler(val) {
				if (!this.itemsMapped || this.itemsMapped.length === 0) {
					this.itemsMapped = val.map(item => {
						return {
							...item, // Copy the new properties from items
							checkedValue: ''
						};
					});
				} else {
					const mappedItemsLookup = new Map(
						this.itemsMapped.map(item => [item.checkedValue, item])
					);

					this.itemsMapped = val.map(newItem => ({
						...newItem,
						checkedValue: mappedItemsLookup.has(newItem.id)
							? mappedItemsLookup.get(newItem.id).checkedValue
							: ''
					}));
				}
			}
		},
		resetSelectedCheckboxes: {
			handler(val) {
				if (val) {
					this.resetCheckedValues();
					this.$emit('resetSelectedCheckboxes', false);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
	* Environment Results List
	* Can use SCSS variables = TRUE
*/
.environment {
	&__list {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-lg;

		@include mq($from: md) {
			grid-template-columns: 1fr 1fr;
		}

		@include mq($from: lg) {
			grid-template-columns: 1fr 1fr 1fr;
		}
	}

	&__item {
		display: flex;

		label {
			flex-grow: 2;
		}
	}
}
</style>
